// An estimate's or an invoice's deposits (deposits.list), read again when `version` moves; none when it
// can't be read. Its own module, so a page drawn with ui-web's parts needn't load Deposits.tsx's sheet.
import { useEffect, useState } from 'react';
import { client } from '../api.ts';
import type { Deposit } from './deposits-model.ts';

export function useDeposits(input: { estimateId: string } | { invoiceId: string }, version: number) {
  const [deposits, setDeposits] = useState<Deposit[] | null>(null);
  const key = JSON.stringify(input);
  useEffect(() => {
    client
      .call<{ deposits: Deposit[] }>('deposits.list', JSON.parse(key))
      .then((r) => setDeposits(r.deposits))
      .catch(() => setDeposits([]));
  }, [key, version]);
  return deposits;
}
